import React from 'react';

interface UsersIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const UsersIcon: React.FC<UsersIconProps> = ({ className = '', color = 'white', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M9.24457 11.7201C9.21457 11.7201 9.19457 11.7201 9.16457 11.7201C9.11457 11.7101 9.04457 11.7101 8.98457 11.7201C6.08457 11.6301 3.89457 9.3501 3.89457 6.5401C3.89457 3.6801 6.22457 1.3501 9.08457 1.3501C11.9446 1.3501 14.2746 3.6801 14.2746 6.5401C14.2646 9.3501 12.0646 11.6301 9.27457 11.7201C9.26457 11.7201 9.25457 11.7201 9.24457 11.7201ZM9.08457 2.8501C7.05457 2.8501 5.39457 4.5101 5.39457 6.5401C5.39457 8.5401 6.95457 10.1501 8.94457 10.2201C9.00457 10.2101 9.13457 10.2101 9.26457 10.2201C11.2246 10.1301 12.7646 8.5201 12.7746 6.5401C12.7746 4.5101 11.1146 2.8501 9.08457 2.8501Z"
        fill="currentColor"
      />
      <path
        d="M16.6246 11.8501C16.5946 11.8501 16.5646 11.8501 16.5346 11.8401C16.1246 11.8801 15.7046 11.5901 15.6646 11.1801C15.6246 10.7701 15.8746 10.4001 16.2846 10.3501C16.4046 10.3401 16.5346 10.3401 16.6446 10.3401C18.1046 10.2601 19.2446 9.0601 19.2446 7.5901C19.2446 6.0701 18.0146 4.8401 16.4946 4.8401C16.0846 4.8501 15.7446 4.5101 15.7446 4.1001C15.7446 3.6901 16.0846 3.3501 16.4946 3.3501C18.8346 3.3501 20.7446 5.2601 20.7446 7.6001C20.7446 9.9001 18.9446 11.7601 16.6546 11.8501C16.6446 11.8501 16.6346 11.8501 16.6246 11.8501Z"
        fill="currentColor"
      />
      <path
        d="M9.25457 22.6501C7.29457 22.6501 5.32457 22.1501 3.83457 21.1501C2.44457 20.2301 1.68457 18.9701 1.68457 17.6001C1.68457 16.2301 2.44457 14.9601 3.83457 14.0301C6.83457 12.0401 11.6946 12.0401 14.6746 14.0301C16.0546 14.9501 16.8246 16.2101 16.8246 17.5801C16.8246 18.9501 16.0646 20.2201 14.6746 21.1501C13.1746 22.1501 11.2146 22.6501 9.25457 22.6501ZM4.66457 15.2901C3.70457 15.9301 3.18457 16.7501 3.18457 17.6101C3.18457 18.4601 3.71457 19.2801 4.66457 19.9101C7.15457 21.5801 11.3546 21.5801 13.8446 19.9101C14.8046 19.2701 15.3246 18.4501 15.3246 17.5901C15.3246 16.7401 14.7946 15.9201 13.8446 15.2901C11.3546 13.6301 7.15457 13.6301 4.66457 15.2901Z"
        fill="currentColor"
      />
      <path
        d="M18.4246 20.8501C18.0746 20.8501 17.7646 20.6101 17.6946 20.2501C17.6146 19.8401 17.8746 19.4501 18.2746 19.3601C18.9046 19.2301 19.4846 18.9801 19.9346 18.6301C20.5046 18.2001 20.8146 17.6601 20.8146 17.0901C20.8146 16.5201 20.5046 15.9801 19.9446 15.5601C19.5046 15.2201 18.9546 14.9801 18.3046 14.8301C17.9046 14.7401 17.6446 14.3401 17.7346 13.9301C17.8246 13.5301 18.2246 13.2701 18.6346 13.3601C19.4946 13.5501 20.2446 13.8901 20.8546 14.3601C21.7846 15.0601 22.3146 16.0501 22.3146 17.0901C22.3146 18.1301 21.7746 19.1201 20.8446 19.8301C20.2246 20.3101 19.4446 20.6601 18.5846 20.8301C18.5246 20.8501 18.4746 20.8501 18.4246 20.8501Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UsersIcon;
